/// ----------------------------------------------------------------------------------------
///Copyright (C) 2016 to the present, Crestron Electronics, Inc.
///All rights reserved.
///No part of this software may be reproduced in any form, machine
///or natural, without the express written consent of Crestron Electronics.
/// ----------------------------------------------------------------------------------------
/// <file>
/// <name>local-store.service.ts</name>
///
/// <description>
///  A service that caches data from hydrogen
///  Follwoing http://blog.angular-university.io/how-to-build-angular2-apps-using-rxjs-observable-data-services-pitfalls-to-avoid/
/// </description>
///
/// <author>Michael Martinez</author>
/// <created>01 Dec 2016</created>
///
/// <changelog>
///   Date  Who Version     Flag Comments
/// ======= === =========== ==== ===========================================================
///  
/// </changelog>
///
/// </file>
/// ----------------------------------------------------------------------------------------
import {Injectable } from '@angular/core';
import {Subject} from 'rxjs/Subject';
import {Observable} from 'rxjs/Observable';
import { Observer } from 'rxjs/Observer';
import { BehaviorSubject } from "rxjs/BehaviorSubject";
import 'rxjs/add/operator/retry';

import {Http, Response} from '@angular/http';
import {MockBackend} from '@angular/http/testing';
import {HydUser} from '../../models/user';
import {LogService} from '../log.service';
import {hydUtilService} from '../../utils/hydUtils.service';
import {DeviceApiService, Device, DevicesSearch  } from '../Crestron.HydrogenAPI.DeviceApi.service';

//YH 1/12/2017 
import {MediatorService} from '../mediator.service';
import {MediatorEventLookup} from '../mediator-event-lookup.service';


@Injectable()
export class DeviceStoreService { 
    private devicesSubject: BehaviorSubject<Device[]>;
    private dataStore: {
        devices: Device[]
    };
    private DeviceStoreSessionStorageName = "DeviceStore";

    public get DevicesObservable(): Observable<Device[]> {
        return this.devicesSubject.asObservable();
    }

    public get DevicesData(): Device[] {
        return Object.assign({}, this.dataStore).devices;
    }

    constructor (
        private _deviceApiService: DeviceApiService,
        private _hydUser: HydUser,
        private _logService : LogService,
        private _mediator:MediatorService
    )
    {
        //YH 4/24/2017 This constructor is called when the user want to refesh the device data from the backend, not to get stale data form session storage
        this.dataStore = { devices: [] };
        //this.LoadDataStoreFromSessionStorage();
        this.devicesSubject = <BehaviorSubject<Device[]>>new BehaviorSubject([]);        
    }

    public Start() {
       
        this._hydUser.AuthorizationObservable.subscribe(
            isLoggedon => {
                let search: DevicesSearch = new DevicesSearch({
                    accountId:this._hydUser.AccountId
                    , sortBy:"DeviceInfo.Name"
                });
                this.LoadInitialData(search);
            }
        );

       //WAIT- This needs to be activated when safe..
      ///  this.subscribeToDeviceUpdateEvents();

    } 

    public RemoveDeviceFromCache(cid:string) {
        if (cid) {
            let removeIndex = this.dataStore.devices.map(device => device.cid).indexOf(cid);
            ~removeIndex && this.dataStore.devices.splice(removeIndex,1);
        }
    }
    
    public updateDeviceStore(deviceId: string): void {
        let obs: any = this._deviceApiService.getDeviceById(deviceId);

        //Subscribe to the update device observable and update the local cache after the device was successfuly updated by the API
        obs.subscribe(
            updatedDevice => {
                this.UpdateDeviceInCache(updatedDevice);
            },
            //TODO notify the user that the device was not created in the backend
            error => { }
        );
    }

    public InsertDeviceIntoCache(device: Device) {
        this.dataStore.devices.push(device);
        this.StoreDataInSessionStorage();
    }

    private LoadInitialData(search: DevicesSearch) {
        let start: Date = new Date();

        this._deviceApiService.getDevices(search)
            .retry(3)
            .subscribe(
            devices => {
                let end: Date = new Date();
                console.debug(hydUtilService.TimeStamp() + " device-store.service LoadInitialData() fetched " + devices.length + " devices for account " + search.accountId + " in " + hydUtilService.TimeLapsMilliseconds(start, end));
                //Store the devices from the API in local memory
                this.dataStore.devices = devices;

                this.StoreDataInSessionStorage();

                this.NotifySubscribersOnNewData();

            },
            err => this._logService.logMessage("device-store.service LoadInitialData() failed fetching devices for account " + search.accountId)
            );
    }

    //YH 1/12/2017 Task 10848
    private subscribeToDeviceUpdateEvents(): void {
        this._mediator.Event(MediatorEventLookup.DeviceStatusUpdate).subscribe(
            (updateDevice) => {
                this.updateDeviceStore(updateDevice.cid);
            }
        );
    }

    private LoadDataStoreFromSessionStorage() {
        this.dataStore = { devices: [] };
        if (typeof (Storage) !== "undefined" && sessionStorage[this.DeviceStoreSessionStorageName]) {
            let parsedDataStore = JSON.parse(sessionStorage[this.DeviceStoreSessionStorageName]);
            //YH 2/9/2017 need to parse each device as it is still a json
            parsedDataStore.devices.map(deviceJson => {
                let deviceAPI: Device = Device.fromJS(deviceJson);
                this.dataStore.devices.push(deviceAPI);
            });
        }
    }

    private StoreDataInSessionStorage() {
        let devicesJson: Array<string> = new Array<string>();
        this.dataStore.devices.map(device => devicesJson.push(device.toJSON()));
        let dataStoreJson = { devices: devicesJson };
        sessionStorage.setItem(this.DeviceStoreSessionStorageName, JSON.stringify(dataStoreJson));
    }

    private NotifySubscribersOnNewData() {
        //Object.assign creates a copy of the data, not returning a reference to the real data. 
        this.devicesSubject.next(Object.assign({}, this.dataStore).devices);
    }

    public UpdateDeviceInCache(device: Device) {
        this.RemoveDeviceFromCache(device.cid);
        this.InsertDeviceIntoCache(device);
    }
}



// WEBPACK FOOTER //
// C:/WS/Fusion/FusionDashboard/src/app/services/device-store/device-store.service.ts